var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{ref:"header",class:{
    'header_full': _vm.active == true,
    'header_search': _vm.searchActive == true,
    'header_breadcrumbed': _vm.breadcrumbs == true,
  }},[_vm._t("default",null,{"toggleSearch":_vm.toggleSearch,"toggleDrawer":_vm.toggleDrawer,"drawerActive":_vm.drawerActive,"toggleSubmenu":_vm.toggleSubmenu,"activeSubmenu":_vm.activeSubmenu})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24a8acb4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheHeader.vue
// module id = null
// module chunks = 